import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Superfície compartilhada com `<Input />` (borda, fundo, padding, tipografia base).
 * Use em composições (ex.: chips + campo) para manter a mesma espessura/cor que o título e demais inputs.
 */
export const inputSurfaceClassName =
  "rounded-md border border-input bg-input-background px-3 py-2 text-base ring-offset-background md:text-sm"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Focus ring inset (dentro do elemento) → não vaza nem é cortado por parents com overflow.
          "flex h-10 w-full file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-inset focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
          inputSurfaceClassName,
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
